import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { AbstractPage } from '../_com/abstract-page';
import { HttpRegistProvider } from '../../providers/http-regist';

/**
 * Generated class for the SmsFollowPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-sms-follow',
  templateUrl: 'sms-follow.html',
})
export class SmsFollowPage extends AbstractPage{

  phoneNumber:"";

  constructor(public navCtrl: NavController, public navParams: NavParams, public httpRegistProvider: HttpRegistProvider, public alertController: AlertController) {
    super();
  }

  /**
   * 対象電話番号のSMS送信済のURLリンクを取得する
   */
  next(){

    this.httpRegistProvider.getSmsLink(this.phoneNumber).subscribe((data) => {

      data = data["data"];

      if ((data["Mail"]) && (data["Mail"]["message"])) {
        this.navCtrl.push("SmsFollowGetLinkPage", { phoneNumber:this.phoneNumber, message: data["Mail"]["message"]});
      } else {
        this.alert(this.alertController, "この電話番号には、まだSMSが送信されていません");
      }
      return;
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/sms-follow/sms-follow.ts